import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/ducks";
import { removeFromCompare } from "../../store/ducks/compare";
import { Box, Button, Typography } from "@mui/material";
import CompareModal from "./CompareModal";

const CompareBar: React.FC = () => {
  const dispatch = useDispatch();
  const items = useSelector((state: RootState) => state.compare.items);

  const [open, setOpen] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  // Show bar again when items list changes
  useEffect(() => {
    if (items.length > 0) {
      setExpanded(false);
      setHidden(false);
    }
  }, [items]);

  if (hidden || !items || items.length === 0) return null;

  const maxSlots = 4;
  const filled = [...items];
  const emptySlots = maxSlots - filled.length;

  return (
    <Box
       onMouseEnter={() => !open && setExpanded(true)}
  onMouseLeave={() => !open && setExpanded(false)}
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "#fff",
        borderTop: "1px solid #ddd",
        boxShadow: "0 -4px 10px rgba(0,0,0,0.15)",
        padding: expanded ? "18px 20px" : "8px 20px",
        height: expanded ? "150px" : "55px",
        overflow: "hidden",
        transition: "all 0.3s ease",
        zIndex: 2000,
      }}
    >
      {/* Items Row */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          height: "100%",
        }}
      >
        {/* Filled slots */}
        {filled.map((item) => (
          <Box
            key={item.SystemId}
            sx={{
              width: expanded ? 140 : 55,
              height: expanded ? 110 : 40,
              border: "2px solid #ddd",
              borderRadius: "8px",
              padding: expanded ? "10px" : "3px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              transition: "all 0.25s ease",
            }}
          >
            <img
              src={item.Image_Source}
              alt={item.Model}
              style={{
                width: expanded ? 45 : 30,
                height: expanded ? 45 : 30,
                objectFit: "contain",
                marginBottom: expanded ? 6 : 0,
              }}
            />

            {expanded && (
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                {item.Model}
              </Typography>
            )}
          </Box>
        ))}

        {/* Empty Slots */}
        {Array.from({ length: emptySlots }).map((_, index) => (
          <Box
            key={index}
            sx={{
              width: expanded ? 160 : 55,
              height: expanded ? 110 : 40,
              border: "2px dashed #bbb",
              borderRadius: "8px",
              opacity: 0.6,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: expanded ? "28px" : "20px",
              color: "#999",
              transition: "all 0.25s ease",
            }}
          >
            +
          </Box>
        ))}

        {/* 🔴 Compare Button */}
        <Button
          variant="contained"
          sx={{
            background: "#E7131A",
            paddingX: expanded ? 4 : 2,
            height: expanded ? "48px" : "35px",
            transition: "all 0.25s ease",
            whiteSpace: "nowrap",
          }}
          onClick={() => {
            setExpanded(false);
            setOpen(true);
          }}
        >
          Compare
        </Button>

        {/* 🟢 Close Compare Button */}
        <Button
          variant="contained"
          sx={{
            background: "green",
            marginLeft: 1,
            paddingX: expanded ? 4 : 2,
            height: expanded ? "48px" : "35px",
            transition: "all 0.25s ease",
            whiteSpace: "nowrap",
          }}
          onClick={() => setHidden(true)}
        >
          Close Compare
        </Button>

        <CompareModal open={open} onClose={() => setOpen(false)} />
      </Box>
    </Box>
  );
};

export default CompareBar;
